var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelshover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_14643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 5.24984C13.3547 5.24984 12.832 4.72717 12.832 4.08317V2.33317C12.832 1.68917 13.3547 1.1665 13.9987 1.1665C14.6427 1.1665 15.1654 1.68917 15.1654 2.33317V4.08317C15.1654 4.72717 14.6427 5.24984 13.9987 5.24984Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4495 23.9797L24.4078 23.268C23.8 23.0557 23.478 22.3907 23.6903 21.7829C23.9027 21.175 24.5677 20.8542 25.1755 21.0654L27.2172 21.777C27.825 21.9894 28.147 22.6544 27.9347 23.2622C27.7223 23.8712 27.0562 24.192 26.4495 23.9797Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0653353 23.2622C-0.146998 22.6543 0.175002 21.9882 0.782835 21.777L2.8245 21.0653C3.4335 20.853 4.09733 21.175 4.30967 21.7828C4.522 22.3907 4.2 23.0568 3.59217 23.268L1.5505 23.9797C0.943835 24.192 0.277669 23.8712 0.0653353 23.2622Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 3.5L25.6654 8.16667L13.9987 12.8333L2.33203 8.16667L13.9987 3.5Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.832 14.8797L2.33203 10.6797V22.1667C2.33203 22.4105 2.4837 22.6299 2.71353 22.7139L12.832 26.4414V14.8797Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.168 14.8797V26.4414L25.2865 22.7139C25.5163 22.6299 25.668 22.4105 25.668 22.1667V10.6797L15.168 14.8797Z",
    fill: "#D42124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_14643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelshover);
export default __webpack_public_path__ + "static/media/modelshover.6537fcd4be1d109ee88cbf7c191203cd.svg";
export { ForwardRef as ReactComponent };